import axios from "axios";
import { baseurl } from "../selectors/baseurl";
export const updateRollInfo = async (rollInfo) => {
  try {
    const updJobDesc = await axios.post(baseurl + "/lattice/editjobdescription", {
      jobID: rollInfo.jid,
      description: rollInfo.description,
      responsibility: rollInfo.responsibility
    });

    const updJobDescRes = await updJobDesc?.data;
    return updJobDescRes;
  } catch (error) {
    console.log('error' + error);
    return 'error';
  }
}
export const insertRollInfo = async (rollInfo) => {
  try {
    const insJobDesc = await axios.post(baseurl + "/lattice/createjobdescription", {
      designationID: rollInfo.designationID,
      latticeID: rollInfo.latticeID,
      description: rollInfo.description,
      responsibility: rollInfo.responsibility
    });

    const insJobDescRes = await insJobDesc?.data;
    return insJobDescRes;
  } catch (error) {
    console.log('error' + error);
    return 'error';
  }
}
export const insertLearningInfo = async (rollInfo) => {
  try {
    const insJobDesc = await axios.post(baseurl + "/lattice/addproposedlearning", {
      jobID: rollInfo.lid,
      learning: rollInfo.learn
    });

    const insJobDescRes = await insJobDesc?.data;
    return insJobDescRes;
  } catch (error) {
    console.log('error' + error);
    return 'error';
  }
}

export const getOthDivData = async (othdivData) => {
  try {
    const getodata = await axios.post(
      baseurl + "/api/lattice/getotherdivision",
      {
        locationID: othdivData.loc,
        divisionID: othdivData.div,
        teamID: othdivData.team,
        streamID: othdivData.stream,
        subStreamID: othdivData.substream
      }
    );
    const insJobDescRes = await getodata?.data;
    console.log(insJobDescRes);
    return getodata;
  } catch (error) {
    console.log('error' + error);
    return 'error';
  }
}